export const selectForm = (state) => state.files.form;
export const selectParams = (state) => state.files.params;
export const selectData = (state) => state.files.data;
export const selectError = (state) => state.files.error;
export const selectFetchCounter = (state) => state.files.fetchCounter;
export const selectLoading = (state) => state.files.loading;
export const selectDownloading = (state) => state.files.downloading;
